import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto px-4 py-24">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="relative bg-white dark:bg-white/5 p-10 md:p-20 rounded-[3.5rem] border border-gray-100 dark:border-gray-800 shadow-2xl overflow-hidden"
      >
        <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 blur-[100px] -mr-32 -mt-32" />
        
        <h1 className="text-4xl md:text-6xl font-black mb-12 dark:text-white underline decoration-primary decoration-8 underline-offset-8">
          Acerca de Appfred
        </h1>

        <div className="space-y-8 text-xl md:text-2xl leading-relaxed text-gray-700 dark:text-gray-300 font-medium">
          {t('about.content').split('\n\n').map((para, i) => (
            <p key={i} className={i === 0 ? "relative z-10" : "relative z-10 p-6 rounded-3xl bg-primary/5 border border-primary/10 italic"}>
              {para}
            </p>
          ))}
        </div>
      </motion.div>
    </div>
  );
}